/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPressReleaseHistoryListSuccessResponseReleaseHistories
 */
export interface GetPressReleaseHistoryListSuccessResponseReleaseHistories {
    /**
     * リリース履歴の一意の識別子
     * @type {number}
     * @memberof GetPressReleaseHistoryListSuccessResponseReleaseHistories
     */
    releaseHistoryId: number;
    /**
     * プレスリリースを変更した企業ユーザーの名前
     * @type {string}
     * @memberof GetPressReleaseHistoryListSuccessResponseReleaseHistories
     */
    changedByCompanyUserName: string;
    /**
     * プレスリリースが変更された日時（ISO 8601形式）
     * @type {Date}
     * @memberof GetPressReleaseHistoryListSuccessResponseReleaseHistories
     */
    changedAt: Date;
}

export function GetPressReleaseHistoryListSuccessResponseReleaseHistoriesFromJSON(json: any): GetPressReleaseHistoryListSuccessResponseReleaseHistories {
    return GetPressReleaseHistoryListSuccessResponseReleaseHistoriesFromJSONTyped(json, false);
}

export function GetPressReleaseHistoryListSuccessResponseReleaseHistoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseHistoryListSuccessResponseReleaseHistories {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseHistoryId': json['release_history_id'],
        'changedByCompanyUserName': json['changed_by_company_user_name'],
        'changedAt': (new Date(json['changed_at'])),
    };
}

export function GetPressReleaseHistoryListSuccessResponseReleaseHistoriesToJSON(value?: GetPressReleaseHistoryListSuccessResponseReleaseHistories | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_history_id': value.releaseHistoryId,
        'changed_by_company_user_name': value.changedByCompanyUserName,
        'changed_at': (value.changedAt.toISOString()),
    };
}

